import { useState, useEffect } from 'react';

import { Content, Icon } from './rack-event.styled';

let interval = null;
const intervalTimeout = 500;

export const RackEvent = (props) => {
  const [showIcon, setShowIcon] = useState(true);
  const { data, type, showWindow, icon } = props;
  const active = data.active;

  // useEffect(() => {
  //   let _mounted = true;
  //   /**
  //    * blink icon
  //    */
  //   const blinkIcon = () => {
  //     interval = setInterval(() => {
  //       if (_mounted) {
  //         setShowIcon((val) => !val);
  //       }
  //     }, intervalTimeout);
  //   };

  //   if (active) {
  //     blinkIcon();
  //   } else {
  //     if (interval) {
  //       clearInterval(interval);
  //     }
  //   }
  //   return () => {
  //     _mounted = false;
  //     if (interval) {
  //       clearInterval(interval);
  //     }
  //   };
  // }, [active]);

  /**
   * show rack window
   */
  const showRackWindow = () => {
    showWindow();
  };

  const path = '/images/' + icon;

  return (
    <Content type={type} $active={active} onClick={showRackWindow}>
      <Icon src={path} style={{ display: active ? 'block' : 'none' }} />
    </Content>
  );
};
